import { HumanProxy, HumanProxySchema } from '../../../types'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type ListHumanProxiesResponsePayload = {
  humanProxies: HumanProxy[]
}

export const ListHumanProxiesResponsePayloadSchema: CborSchema<ListHumanProxiesResponsePayload> =
  defineCborSchema<ListHumanProxiesResponsePayload>({
    humanProxies: CborField({ key: 0, arrayItemType: HumanProxySchema }),
  })
